<template>
  <abk-offer-invitations-list offer-invitations-type="archived"/>
</template>

<script>
import AbkOfferInvitationsList from '../../../components/offer_invitations/AbkOfferInvitationsList'

export default {
  name: 'OfferInvitationsArchivedTab',
  components: { AbkOfferInvitationsList },
  methods: {
    setHeader () {
      this.$store.dispatch('header/setHeader', {
        title: this.$t('views.offer_invitations.list_tabs.archived.title'),
        subtitle: this.$t('views.offer_invitations.list_tabs.archived.subtitle')
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.setHeader()
    })
  }
}
</script>
